var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDartBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1751_6590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7989 8.20097C42.5105 2.91247 35.4791 0 28 0C20.5209 0 13.4895 2.91247 8.20108 8.20097C2.91247 13.4895 0 20.5209 0 28C0 35.4791 2.91247 42.5105 8.20097 47.799C13.4894 53.0875 20.5209 56 27.9999 56C35.4789 56 42.5104 53.0875 47.7988 47.799C53.0873 42.5105 55.9998 35.4791 55.9998 28C55.9998 20.5209 53.0875 13.4895 47.7989 8.20097Z",
    fill: "var(--primary-700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 45.7655C37.8116 45.7655 45.7655 37.8116 45.7655 27.9999C45.7655 18.1883 37.8116 10.2344 27.9999 10.2344C18.1883 10.2344 10.2344 18.1883 10.2344 27.9999C10.2344 37.8116 18.1883 45.7655 27.9999 45.7655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0009 35.8436C32.3334 35.8436 35.8456 32.3314 35.8456 27.9989C35.8456 23.6665 32.3334 20.1543 28.0009 20.1543C23.6684 20.1543 20.1562 23.6665 20.1562 27.9989C20.1562 32.3314 23.6684 35.8436 28.0009 35.8436Z",
    fill: "var(--primary-700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3362 7.66347L47.0754 1.35938L38.457 9.97769L39.7177 16.2819L46.0218 17.5427L54.6402 8.92426L48.3362 7.66347Z",
    fill: "#FFD321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3362 7.66347L47.0754 1.35938L38.457 9.97769L39.7177 16.2819L46.0218 17.5427L54.6402 8.92426L48.3362 7.66347Z",
    fill: "#E48E45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0078 25.666L39.3231 14.3507L41.6428 16.6704L30.3275 27.9857L28.0078 25.666Z",
    fill: "#0A2629"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1751_6590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartBoard);
export default __webpack_public_path__ + "static/media/dart-board.9277f8a7c6b03c3b69f48664a6abcbe5.svg";
export { ForwardRef as ReactComponent };